import { NavigateWithThread, FocusDashboard, Profile, TopSkillDetailPage } from '@yeshuman/sdk'
import { Routes, Route } from 'react-router-dom'
import { BriefsPage } from '../../../components/recruiter/briefs-page'
import { BriefCreatePage } from '../../../components/recruiter/brief-create-page'
import { BriefDetailPage } from '../../../components/recruiter/brief-detail-page'
import { RecruiterTalentPage } from '../../../components/recruiter/recruiter-talent-page'
import { RecruiterEvaluationAnalysisRoute } from '../../../components/recruiter/recruiter-evaluation-analysis-route'
import { RecruiterPersonMatchPage } from '../../../components/recruiter/recruiter-person-match-page'
import { RolesPage } from '../../../components/recruiter/roles-page'
import { RoleDetailPage } from '../../../components/recruiter/role-detail-page'

interface RecruiterRoutesProps {
  onStartConversation?: (message: string) => void
}

export function RecruiterRoutes({ onStartConversation }: RecruiterRoutesProps) {
  return (
    <Routes>
      <Route
        index
        element={
          <FocusDashboard
            focus="recruiter"
            onStartConversation={onStartConversation}
          />
        }
      />
      <Route path="profile/top-skills/:skillId" element={<TopSkillDetailPage />} />
      <Route path="profile" element={<Profile />} />
      <Route path="talent/analysis/:evaluationId" element={<RecruiterEvaluationAnalysisRoute />} />
      <Route path="talent/people/:profileId" element={<RecruiterPersonMatchPage />} />
      <Route path="talent" element={<RecruiterTalentPage />} />
      <Route path="briefs/:briefId/people/:profileId" element={<RecruiterPersonMatchPage />} />
      <Route path="briefs" element={<BriefsPage />} />
      <Route path="briefs/new" element={<BriefCreatePage />} />
      <Route path="briefs/:briefId" element={<BriefDetailPage />} />
      <Route path="roles" element={<RolesPage />} />
      <Route path="roles/:roleId" element={<RoleDetailPage />} />
      <Route path="*" element={<NavigateWithThread to="" />} />
    </Routes>
  )
}
